import { Body } from "./components/Body/Body";
import { Footer } from "./components/Footer/Footer";
import { Wrapper } from "./components/Wrapper/Wrapper";
import { InsightTooltip as Tooltip } from "./components/Tooltip/Tooltip";

export const Insight = { Wrapper, Body, Footer, Tooltip };
